// Number-only TextField — disables mouse wheel increment/decrement, matches the Angular
// NumberInputFieldComponent + DisableWheelDirective behavior.
import { TextField, TextFieldProps } from '@mui/material';

export type NumberInputFieldProps = Omit<TextFieldProps, 'type' | 'onWheel'>;

export function NumberInputField(props: NumberInputFieldProps) {
  return (
    <TextField
      {...props}
      type="number"
      onWheel={(e) => {
        // Prevent accidental value change when scrolling over a focused number input.
        (e.target as HTMLInputElement).blur();
        e.preventDefault();
      }}
    />
  );
}
